import React, { Component } from 'react'
const popins = Poppins({weight:"500", subsets:['latin']});
const extraPopins = Poppins({weight: "400", subsets: ['latin']});
import { Poppins } from 'next/font/google'

export default class Para extends Component {
  render() {
    return (
      <>
      <div className="pdt20">
            {/* <h2 className='fs25 mfs-24 mfwb600'>{this.props.heading}</h2> */}
            <h3 className={`fs-32 mfs-20   mfwb600 mpdb5 pdb10 ylw-clr ${popins.className}`}>{this.props.heading3}</h3>
            <div className={`fs-19 cg mfs14 mlhs20 lh3 ${extraPopins.className}`}>{this.props.content}</div>
      </div>
      </>
    )
  }
}
